import React, { useState, useEffect } from "react";
import Menu from './menu/menu.jsx';
import Footer from './menu/footer.jsx';
import { Container } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from "react-bootstrap/Card";
import Button from 'react-bootstrap/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useParams } from "react-router-dom";

import {I18nPropvider, LOCALES} from './../i18nProvider';
import { FormattedMessage } from 'react-intl';
import { useLocation, Link } from "react-router-dom";
import MapCoverage from "./mapCoverage.jsx";
import { TailSpin } from "react-loader-spinner";
import { getBeam, coordinatesFormater, getPowersLevelWithCoord } from './../services/service.jsx'

function formatOrbitalPosition(orbitalPosition) {
    if (orbitalPosition !== undefined && orbitalPosition != null) {
        var data = orbitalPosition.split("°");
        var value = data[0];
        var position = data[1];
        orbitalPosition = parseFloat(value) + "°" + position;
    }
    return orbitalPosition;
}

export function InfoChaine({ langue }) {
    const params = useParams();
    let channelId = params.id.match(/\d+/);
    const [beam, setBeam] = useState([]);
    const [channel, setChannel] = useState([]);
    const [satellite, setSatellite] = useState([]);
    const location = useLocation().state;

    let language = LOCALES.ENGLISH;

    const [locale, setLocale] = useState((location && location.locale ?location.locale : language));

    const [loading, setLoading] = useState(true);

    const [mapPolygons, setMapPolygons] = useState([]);
    const [powerLevelWithCoord, setPowerLevelWithCoord] = useState([]);

    useEffect(() => {
        function fetchChannelDetailDataLineUp() {
            fetch(`/lineup/api/lineup/${channelId}`)
                .then(response => {
                    response.json().then(data => {
                        setChannel(data)
                        if (typeof data.satellite !== "undefined") {
                            setSatellite(data.satellite)
                            getBeamOfSatellite(data.satellite, data)
                        }
                    }).catch(err => {
                        console.log("Erreur lors de la recupération des données de la chaines. Id inexistant");
                        console.log(err)
                    })
                }).catch(err => {
                    console.log("Impossible d'accéder à l'api lineup");
                    console.log(err)
                });
        }
        function getBeamOfSatellite(satellite, channel) {
            if (satellite != "undefined") {
                fetch(`/lineup/api/beam/${satellite.idSatellite}`)
                    .then(response => {
                        response.json().then(beams => {
                            let beam = getBeam(beams, channel.beamName)
                            if (typeof beam !== "undefined") {
                                setBeam(beam)
                                let mapPolygonBeam = beam.downlink.mapPolygons
                                let beamCoordinate = coordinatesFormater(mapPolygonBeam)
                                setMapPolygons(beamCoordinate)
                                setPowerLevelWithCoord(getPowersLevelWithCoord(mapPolygonBeam, beamCoordinate))
                            }
                            else {
                                console.log("No beam to display")
                            }
                            setLoading(false)
                        }).catch(err => {
                            setLoading(false)
                            console.log("Erreur lors de la recupération des données beam.");
                            console.log(err)
                        })
                    }).catch(err => {
                        setLoading(false)
                        console.log("Impossible d'accéder à l'api lineup");
                        console.log(err)
                    });
            }
        }

        fetchChannelDetailDataLineUp();
    }, []);


    return (
        <div className="App overflow-auto" >
            <I18nPropvider locale={locale}>
                <header className="App-header">
                    <div>
                        <Menu locale={locale} onChangeValue={(data) => { setLocale(data) }}></Menu>
                    </div>
                </header>
                <br />

                <Container className="channelDetailContainer">
                    <Card bg="white">
                        <Row>
                            <Col>
                                <Link to={{ pathname: "/", search: (locale === undefined ? "" : "?Langue=" + locale) }}                                >
                                    <Button type="button" className="backButton"  aria-label="Back" title="Back">{<ArrowBackIcon  />}</Button>
                                </Link>

                            </Col>
                        </Row>
                        <Card.Body>
                            <h3 className="detailChannelName">{channel.channelName}</h3>
                            <br />
                            <Row>
                                <div className="col-6 col-md-6 col-lg-2">
                                    <h3 className="detailTitle"><FormattedMessage id="generalInformation" /></h3>
                                    <label className="labelInfo"><FormattedMessage id="encryption" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="language" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="genre" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="resolution" /></label><br />

                                    <br /><br />
                                    <h3 className="detailTitle"><FormattedMessage id="technicalInformation" /></h3>
                                    <label className="labelInfo"><FormattedMessage id="satellite" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="orbitalPosition" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="beam" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="frequency" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="polarization" /></label><br />
                                    <label className="labelInfo"><FormattedMessage id="symbolRate" /></label><br />

                                </div>
                                <div className="col-6 col-md-6 col-lg-2">
                                    <h3 className="detailTitle">&nbsp;</h3>
                                    <label className="valueInfo">{channel.encrypted === true ? "Free to air" : "Encoded"}</label><br />
                                    <label className="valueInfo">{channel.language}</label><br />
                                    <label className="valueInfo">{channel.theme}</label><br />
                                    <label className="valueInfo">{channel.sdHd}</label><br />

                                    <br /><br />
                                    <h3 className="detailTitle">&nbsp;</h3>
                                    <label className="valueInfo">{satellite.name}</label><br />
                                    <label className="valueInfo">{formatOrbitalPosition(satellite.orbitalPosition)}</label><br /> {/* <label className="valueInfo">{satellite.orbitalPosition}</label><br /> */}
                                    <label className="valueInfo">{channel.beamName}</label><br />
                                    <label className="valueInfo">{channel.frequency}</label><br />
                                    <label className="valueInfo">{channel.polarisation}</label><br />
                                    <label className="valueInfo">{channel.symbolRate}</label><br />


                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-4">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {
                                            loading && (
                                                <TailSpin id="tailSpin" color="#3388ff"></TailSpin>
                                            )
                                        }
                                    </div>
                                    {
                                        !loading && (
                                            <div id="map" style={{ height: "50vh", width: "100%" }}>
                                                <MapCoverage satellite={satellite} mapPolygons={mapPolygons} powerLevelWithCoord={powerLevelWithCoord} beam={beam}></MapCoverage>
                                            </div>
                                        )
                                    }

                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-4">
                                    <Row>
                                        <div className="col-md-12">
                                            <label className="labelAntenna"><FormattedMessage id="tableOfDbw" /></label><br />
                                            <label className="labelAntenna"><FormattedMessage id="tableOfDbwAntennaSize" /></label>
                                            <br />
                                            <br />

                                            <label className="descriptionLabelAntenna"><FormattedMessage id="tableOfDbwTitleLine1" /> </label><br />
                                            <label className="descriptionLabelAntenna"><FormattedMessage id="tableOfDbwTitleLine2" /> </label><br />
                                            <label className="descriptionLabelAntenna"><FormattedMessage id="tableOfDbwTitleLine3" /></label><br />
                                            <br />
                                        </div>
                                        <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                                            <h3 className="coverageAndAntenna"><FormattedMessage id="coverage" /></h3>

                                            <label className="valueCoverageAndAntenna">53-49 dBW</label><br />
                                            <label className="valueCoverageAndAntenna">48 dBW</label><br />
                                            <label className="valueCoverageAndAntenna">47 dBW</label><br />
                                            <label className="valueCoverageAndAntenna">46 dBW</label><br />
                                            <label className="valueCoverageAndAntenna">44 dBW</label><br />
                                            <label className="valueCoverageAndAntenna">42 dBW</label><br />
                                            <label className="valueCoverageAndAntenna">40 dBW</label><br />
                                        </div>
                                        <div className="col-6 col-sm-6 col-md-6">
                                            <h3 className="coverageAndAntenna"><FormattedMessage id="antennaSize" /></h3>

                                            <label className="valueCoverageAndAntenna">70 cm</label><br />
                                            <label className="valueCoverageAndAntenna">75 cm</label><br />
                                            <label className="valueCoverageAndAntenna">80 cm</label><br />
                                            <label className="valueCoverageAndAntenna">90 cm</label><br />
                                            <label className="valueCoverageAndAntenna">1.2 m</label><br />
                                            <label className="valueCoverageAndAntenna">1.5 m</label><br />
                                            <label className="valueCoverageAndAntenna">1.8 m</label><br />
                                        </div>

                                        {mapPolygons.length > 0 &&
                                            <Link to="/detailSatellite" state={{
                                                locale: locale, satellite: satellite,
                                                mapPolygons: mapPolygons, powerLevelWithCoord: powerLevelWithCoord, beam: beam
                                            }}>
                                                <label className="satellitesDetails"><FormattedMessage id="satelliteDetails" /><ArrowForwardIcon sx={{ fontSize: 15 }} /></label>
                                            </Link>
                                        }
                                    </Row>
                                </div>

                            </Row>
                        </Card.Body>
                    </Card>
                </Container>

                <div className="clear"></div>

                <footer className="footer">
                    <Footer></Footer>
                </footer>
            </I18nPropvider>
        </div >

    );
}
export default InfoChaine;
